import { HttpClient, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environment';
import { UserAsset } from '@interfaces';
import { Observable } from 'rxjs';

import { MyWorkPermit } from '../../work-permits/work-permits.interfaces';

@Injectable({
  providedIn: 'root',
})
export class MyWorkPermitsHttpService {
  private readonly http = inject(HttpClient);

  private API_URL = environment.API_URL;
  private FULL_URL = `${this.API_URL}/my-work-permits`;

  public getMyWorkPermits(): Observable<MyWorkPermit[]> {
    return this.http.get<MyWorkPermit[]>(this.FULL_URL);
  }

  public getMyWorkPermit(workPermitId: string): Observable<MyWorkPermit> {
    return this.http.get<MyWorkPermit>(`${this.FULL_URL}/${workPermitId}`);
  }

  public uploadDocumentFile(workPermitId: string, documentId: string, file: File): Observable<UserAsset> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<UserAsset>(`${this.FULL_URL}/${workPermitId}/documents/${documentId}/files`, formData);
  }

  public removeDocumentFile(workPermitId: string, documentId: string, userAssetId: string): Observable<unknown> {
    return this.http.delete(`${this.FULL_URL}/${workPermitId}/documents/${documentId}/files/${userAssetId}`);
  }

  public downloadDocumentFile(
    workPermitId: string,
    documentId: string,
    userAssetId: string
  ): Observable<HttpResponse<Blob>> {
    return this.http.get(`${this.FULL_URL}/${workPermitId}/documents/${documentId}/files/${userAssetId}`, {
      responseType: 'blob',
      observe: 'response',
    });
  }
}
